import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Filter } from "lucide-react";
import { Panel } from "./primitives";

const STATUS_COLOR = { ahead: "#059669", behind: "#d97706", critical: "#e11d48", neutral: "hsl(200 100% 28%)" };

export function GoalFunnel({ progress, drill, index }) {
  const reduce = useReducedMotion();
  if (!progress?.has_goal || !(progress.funnel || []).length) return null;
  return (
    <Panel title={`${progress.year} Recruiting Goal Funnel`} icon={Filter} testId="goal-funnel" index={index}>
      <div className="space-y-3" data-testid="goal-funnel-rows">
        {progress.funnel.map((f) => {
          const pct = f.ytd_target > 0 ? Math.min(100, Math.round((f.ytd_actual / f.ytd_target) * 100)) : (f.ytd_actual > 0 ? 100 : 0);
          const color = STATUS_COLOR[f.status] || STATUS_COLOR.neutral;
          const v = f.variance;
          return (
            <button key={f.key} data-testid={`goal-funnel-${f.key}`} onClick={() => drill({ tab: "all" })}
              className="w-full text-left group">
              <div className="flex items-center justify-between text-xs mb-1">
                <span className="font-medium text-slate-700 group-hover:text-brand uppercase tracking-wide text-[11px]">{f.label}</span>
                <span className="text-slate-500">{f.ytd_actual} / {f.ytd_target} <span className="text-slate-400">YTD</span>
                  {f.ytd_target > 0 && <span className="ml-1.5 font-medium" style={{ color }}>{v >= 0 ? `+${v}` : v}</span>}</span>
              </div>
              <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
                <motion.div className="h-full rounded-full" style={{ background: color }}
                  initial={reduce ? false : { width: 0 }} animate={{ width: `${pct}%` }} transition={{ duration: 0.6, ease: "easeOut" }} />
              </div>
            </button>
          );
        })}
      </div>
    </Panel>
  );
}
